import invariant from 'tiny-invariant';
import { ListInterpreter, MapInterpreter, isOlderVS } from '@roomservice/core';

// export const WS_URL = 'ws://localhost:3452';
// export const DOCS_URL = 'http://localhost:3454/docs';
// export const PRESENCE_URL = 'http://localhost:3454/presence';
var WS_URL = 'wss://super.roomservice.dev/ws';
var DOCS_URL = 'https://super.roomservice.dev/docs';
var PRESENCE_URL = 'https://super.roomservice.dev/presence';

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[Symbol.iterator]();
  return it.next.bind(it);
}

// A type of promise-like that resolves synchronously and supports only one observer
const _Pact = /*#__PURE__*/(function() {
	function _Pact() {}
	_Pact.prototype.then = function(onFulfilled, onRejected) {
		const result = new _Pact();
		const state = this.s;
		if (state) {
			const callback = state & 1 ? onFulfilled : onRejected;
			if (callback) {
				try {
					_settle(result, 1, callback(this.v));
				} catch (e) {
					_settle(result, 2, e);
				}
				return result;
			} else {
				return this;
			}
		}
		this.o = function(_this) {
			try {
				const value = _this.v;
				if (_this.s & 1) {
					_settle(result, 1, onFulfilled ? onFulfilled(value) : value);
				} else if (onRejected) {
					_settle(result, 1, onRejected(value));
				} else {
					_settle(result, 2, value);
				}
			} catch (e) {
				_settle(result, 2, e);
			}
		};
		return result;
	};
	return _Pact;
})();

// Settles a pact synchronously
function _settle(pact, state, value) {
	if (!pact.s) {
		if (value instanceof _Pact) {
			if (value.s) {
				if (state & 1) {
					state = value.s;
				}
				value = value.v;
			} else {
				value.o = _settle.bind(null, pact, state);
				return;
			}
		}
		if (value && value.then) {
			value.then(_settle.bind(null, pact, state), _settle.bind(null, pact, 2));
			return;
		}
		pact.s = state;
		pact.v = value;
		const observer = pact.o;
		if (observer) {
			observer(pact);
		}
	}
}

function _isSettledPact(thenable) {
	return thenable instanceof _Pact && thenable.s & 1;
}

const _iteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))) : "@@iterator";

const _asyncIteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator"))) : "@@asyncIterator";

// Asynchronously implement a generic for loop
function _for(test, update, body) {
	var stage;
	for (;;) {
		var shouldContinue = test();
		if (_isSettledPact(shouldContinue)) {
			shouldContinue = shouldContinue.v;
		}
		if (!shouldContinue) {
			return result;
		}
		if (shouldContinue.then) {
			stage = 0;
			break;
		}
		var result = body();
		if (result && result.then) {
			if (_isSettledPact(result)) {
				result = result.s;
			} else {
				stage = 1;
				break;
			}
		}
		if (update) {
			var updateValue = update();
			if (updateValue && updateValue.then && !_isSettledPact(updateValue)) {
				stage = 2;
				break;
			}
		}
	}
	var pact = new _Pact();
	var reject = _settle.bind(null, pact, 2);
	(stage === 0 ? shouldContinue.then(_resumeAfterTest) : stage === 1 ? result.then(_resumeAfterBody) : updateValue.then(_resumeAfterUpdate)).then(void 0, reject);
	return pact;
	function _resumeAfterBody(value) {
		result = value;
		do {
			if (update) {
				updateValue = update();
				if (updateValue && updateValue.then && !_isSettledPact(updateValue)) {
					updateValue.then(_resumeAfterUpdate).then(void 0, reject);
					return;
				}
			}
			shouldContinue = test();
			if (!shouldContinue || (_isSettledPact(shouldContinue) && !shouldContinue.v)) {
				_settle(pact, 1, result);
				return;
			}
			if (shouldContinue.then) {
				shouldContinue.then(_resumeAfterTest).then(void 0, reject);
				return;
			}
			result = body();
			if (_isSettledPact(result)) {
				result = result.v;
			}
		} while (!result || !result.then);
		result.then(_resumeAfterBody).then(void 0, reject);
	}
	function _resumeAfterTest(shouldContinue) {
		if (shouldContinue) {
			result = body();
			if (result && result.then) {
				result.then(_resumeAfterBody).then(void 0, reject);
			} else {
				_resumeAfterBody(result);
			}
		} else {
			_settle(pact, 1, result);
		}
	}
	function _resumeAfterUpdate() {
		if (shouldContinue = test()) {
			if (shouldContinue.then) {
				shouldContinue.then(_resumeAfterTest).then(void 0, reject);
			} else {
				_resumeAfterTest(shouldContinue);
			}
		} else {
			_settle(pact, 1, result);
		}
	}
}

// Asynchronously call a function and send errors to recovery continuation
function _catch(body, recover) {
	try {
		var result = body();
	} catch(e) {
		return recover(e);
	}
	if (result && result.then) {
		return result.then(void 0, recover);
	}
	return result;
}

var fetchSession = function fetchSession(params) {
  try {
    var _temp3 = function _temp3(_result) {
      if (_exit2) return _result;
      // The generic function
      var url = strategy;
      return Promise.resolve(fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          resources: [{
            object: 'document',
            reference: document,
            permission: 'read_write',
            room: room
          }, {
            object: 'room',
            reference: room,
            permission: 'join'
          }]
        })
      })).then(function (res) {
        if (res.status === 401) {
          throw new Error('The Auth Webhook returned unauthorized.');
        }

        if (res.status !== 200) {
          throw new Error('The Auth Webhook returned a status code other than 200.');
        }

        return Promise.resolve(res.json()).then(function (json) {
          var resources = json.resources,
              token = json.token,
              user = json.user;

          if (!resources || !token || !user) {
            if (json.body === 'Unauthorized') {
              throw new Error('The Auth Webhook unexpectedly return unauthorized. You may be using an invalid API key.');
            }

            throw new Error('The Auth Webhook has an incorrectly formatted JSON response.');
          }

          var docID = resources.find(function (r) {
            return r.object === 'document';
          }).id;
          var roomID = resources.find(function (r) {
            return r.object === 'room';
          }).id;
          return {
            token: token,
            guestReference: user,
            docID: docID,
            roomID: roomID
          };
        });
      });
    };

    var _exit2 = false;
    var _params$authBundle = params.authBundle,
        strategy = _params$authBundle.strategy,
        ctx = _params$authBundle.ctx,
        room = params.room,
        document = params.document; // A user defined function

    var _temp4 = function () {
      if (typeof strategy === 'function') {
        return Promise.resolve(strategy({
          room: room,
          ctx: ctx
        })).then(function (result) {
          if (!result.user) {
            throw new Error("The auth function must return a 'user' key.");
          }

          var docID = result.resources.find(function (r) {
            return r.object === 'document';
          }).id;
          var roomID = result.resources.find(function (r) {
            return r.object === 'room';
          }).id;
          _exit2 = true;
          return {
            token: result.token,
            guestReference: result.user,
            docID: docID,
            roomID: roomID
          };
        });
      }
    }();

    return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(_temp3) : _temp3(_temp4));
  } catch (e) {
    return Promise.reject(e);
  }
};
var fetchDocument = function fetchDocument(url, token, docID) {
  try {
    return Promise.resolve(fetch(url + '/' + docID, {
      headers: {
        Authorization: 'Bearer: ' + token
      }
    })).then(function (res) {
      return Promise.resolve(res.json()).then(function (doc) {
        return doc.body;
      });
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var fetchPresence = function fetchPresence(url, token, roomID) {
  try {
    return Promise.resolve(fetch(url + '/' + roomID, {
      headers: {
        Authorization: 'Bearer: ' + token
      }
    })).then(function (res) {
      return Promise.resolve(res.json()).then(function (doc) {
        // Parse JSON values
        for (var _i = 0, _Object$keys = Object.keys(doc); _i < _Object$keys.length; _i++) {
          var key = _Object$keys[_i];

          for (var _i2 = 0, _Object$keys2 = Object.keys(doc[key]); _i2 < _Object$keys2.length; _i2++) {
            var actor = _Object$keys2[_i2];

            if (typeof doc[key][actor].value === 'string') {
              var json = void 0;

              try {
                json = JSON.parse(doc[key][actor].value);
              } catch (err) {}

              if (json) {
                doc[key][actor].value = json;
              }
            }
          }
        }

        return doc;
      });
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var fetchBootstrapState = function fetchBootstrapState(props) {
  try {
    return Promise.resolve(Promise.all([fetchPresence(props.presenceURL, props.token, props.roomID), fetchDocument(props.docsURL, props.token, props.docID)])).then(function (_ref) {
      var allPresence = _ref[0],
          documentCheckpoint = _ref[1];
      return {
        presence: allPresence,
        document: documentCheckpoint
      };
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

function delay(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}

var openWS = function openWS(url) {
  try {
    return Promise.resolve(new Promise(function (resolve, reject) {
      var ws = new WebSocket(url);

      ws.onopen = function () {
        resolve(ws);
      };

      ws.onerror = function (err) {
        reject(err);
      };
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};

var WEBSOCKET_TIMEOUT = 1000 * 2;
var MAX_UNSENT_DOC_CMDS = 10000;
var FORWARDED_TYPES = ['doc:fwd', 'presence:fwd', 'room:rm_guest'];
var ReconnectingWebSocket = /*#__PURE__*/function () {
  function ReconnectingWebSocket(params) {
    this.callbacks = {};
    this.lastTime = 0;
    this.msgsThisMilisecond = 0;
    this.docCmdSendQueue = []; //  only most recent presence cmd per-key is kept

    this.presenceCmdSendQueue = new Map();
    this.dispatcher = params.dispatcher;
    this.wsURL = params.wsURL;
    this.docsURL = params.docsURL;
    this.presenceURL = params.presenceURL;
    this.room = params.room;
    this.document = params.document;
    this.authBundle = params.authBundle;
    this.wsFactory = params.wsFactory || openWS;
    this.bootstrapFetch = params.bootstrapFetch || fetchBootstrapState;
    this.sessionFetch = params.sessionFetch || fetchSession;
    this.wsLoop();
  }

  var _proto = ReconnectingWebSocket.prototype;

  _proto.close = function close() {
    if (this.currentConn) {
      this.currentConn.onmessage = null;
      this.currentConn.onclose = null;
      this.currentConn.close();
      this.currentConn = undefined;
    }

    if (this.pendingConn) {
      this.pendingConn = undefined;
    }

    this.dispatcher.startQueueingCmds();
  } //  one-off attempt to connect and authenticate
  ;

  _proto.connectAndAuth = function connectAndAuth() {
    try {
      var _temp3 = function _temp3() {
        var session = _this2.session;
        return Promise.resolve(_this2.wsFactory(_this2.wsURL)).then(function (ws) {
          ws.onmessage = function (ev) {
            var msg = JSON.parse(ev.data);

            _this2.dispatch(msg.type, msg.body);
          };

          ws.onclose = function () {
            return _this2.close();
          };

          return Promise.resolve(ws).then(function (ws) {
            try {
              ws.send(_this2.serializeMsg('guest:authenticate', session.token));
              return Promise.resolve(_this2.once('guest:authenticated')).then(function () {
                ws.send(_this2.serializeMsg('room:join', session.roomID));
                return Promise.resolve(_this2.once('room:joined')).then(function () {
                  return Promise.resolve(_this2.bootstrapFetch({
                    docID: session.docID,
                    roomID: session.roomID,
                    docsURL: _this2.docsURL,
                    presenceURL: _this2.presenceURL,
                    token: session.token
                  })).then(function (bootstrapState) {
                    _this2.dispatcher.bootstrap(session.guestReference, bootstrapState);

                    return ws;
                  });
                });
              });
            } catch (e) {
              return Promise.reject(e);
            }
          });
        });
      };

      var _this2 = this;

      var _temp4 = function () {
        if (!_this2.session) {
          return Promise.resolve(_this2.sessionFetch({
            authBundle: _this2.authBundle,
            room: _this2.room,
            document: _this2.document
          })).then(function (_this$sessionFetch) {
            _this2.session = _this$sessionFetch;
          });
        }
      }();

      return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(_temp3) : _temp3(_temp4));
    } catch (e) {
      return Promise.reject(e);
    }
  } //  main logic to obtain an active and auth'd connection
  ;

  _proto.conn = function conn() {
    try {
      var _this4 = this;

      if (_this4.currentConn) {
        return Promise.resolve(_this4.currentConn);
      }

      if (_this4.pendingConn) {
        return Promise.resolve(_this4.pendingConn);
      }

      _this4.close();

      _this4.pendingConn = function () {
        try {
          var _exit2 = false;
          var delayMs = 0;
          var maxDelayMs = 60 * 1000;
          return Promise.resolve(_for(function () {
            return !_exit2;
          }, void 0, function () {
            var jitteredDelay = delayMs * (Math.random() + 1) / 2;
            return Promise.resolve(delay(jitteredDelay)).then(function () {
              delayMs = Math.min(2 * delayMs + 100, maxDelayMs);
              return _catch(function () {
                return Promise.resolve(_this4.connectAndAuth()).then(function (ws) {
                  _this4.currentConn = ws;
                  _this4.pendingConn = undefined;
                  _exit2 = true;
                  return ws;
                });
              }, function (err) {
                console.error('Connection to RoomService failed with', err, '\nRetrying...');
              });
            });
          }));
        } catch (e) {
          return Promise.reject(e);
        }
      }();

      return Promise.resolve(_this4.pendingConn);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.wsLoop = function wsLoop() {
    try {
      var _this6 = this;

      var _temp6 = _for(function () {
        return true;
      }, void 0, function () {
        return Promise.resolve(_this6.conn()).then(function () {
          _this6.processSendQueue();

          return Promise.resolve(delay(1000)).then(function () {});
        });
      });

      return Promise.resolve(_temp6 && _temp6.then ? _temp6.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.timestamp = function timestamp() {
    var time = Date.now();

    if (time === this.lastTime) {
      this.msgsThisMilisecond++;
    } else {
      this.lastTime = time;
      this.msgsThisMilisecond = 0;
    }

    return time + ":" + this.msgsThisMilisecond;
  };

  _proto.serializeMsg = function serializeMsg(msgType, body) {
    var ts = this.timestamp();
    var msg = {
      type: msgType,
      ts: ts,
      ver: 0,
      body: body
    };
    return JSON.stringify(msg);
  };

  _proto.send = function send(msgType, body) {
    if (msgType == 'doc:cmd') {
      if (this.docCmdSendQueue.length >= MAX_UNSENT_DOC_CMDS) {
        throw 'RoomService send queue full';
      }

      var docBody = body;
      this.docCmdSendQueue.push(docBody);
    }

    if (msgType == 'presence:cmd') {
      var presenceBody = body;
      this.presenceCmdSendQueue.set(presenceBody.key, body);
    }

    this.processSendQueue();
  };

  _proto.processSendQueue = function processSendQueue() {
    if (!this.currentConn || !this.session) {
      return;
    }

    try {
      while (this.presenceCmdSendQueue.size > 0) {
        var first = this.presenceCmdSendQueue.entries().next();

        if (first) {
          var _first$value = first.value,
              key = _first$value[0],
              msg = _first$value[1];
          var json = this.serializeMsg('presence:cmd', msg);
          this.currentConn.send(json);
          this.presenceCmdSendQueue["delete"](key);
        }
      }

      while (this.docCmdSendQueue.length > 0) {
        var _msg = this.docCmdSendQueue[0];

        var _json = this.serializeMsg('doc:cmd', _msg);

        this.currentConn.send(_json);
        this.docCmdSendQueue.splice(0, 1);
      }
    } catch (e) {
      console.error(e);
    }
  };

  _proto.bind = function bind(msgType, callback) {
    this.callbacks[msgType] = this.callbacks[msgType] || [];
    this.callbacks[msgType].push(callback);
    return callback;
  };

  _proto.unbind = function unbind(msgType, callback) {
    this.callbacks[msgType] = this.callbacks[msgType].filter(function (c) {
      return c !== callback;
    });
  };

  _proto.dispatch = function dispatch(msgType, body) {
    if (msgType == 'error') {
      console.error(body);
    }

    var stack = this.callbacks[msgType];

    if (stack) {
      for (var i = 0; i < stack.length; i++) {
        stack[i](body);
      }
    }

    if (FORWARDED_TYPES.includes(msgType)) {
      this.dispatcher.forwardCmd(msgType, body);
    }
  };

  _proto.once = function once(msg) {
    try {
      var _this8 = this;

      var off;
      return Promise.race([new Promise(function (_, reject) {
        return setTimeout(function () {
          return reject('timeout');
        }, WEBSOCKET_TIMEOUT);
      }), new Promise(function (resolve) {
        off = _this8.bind(msg, function (body) {
          resolve(body);
        });
      })]).then(function () {
        if (off) _this8.unbind(msg, off);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return ReconnectingWebSocket;
}();

var InnerListClient = /*#__PURE__*/function () {
  function InnerListClient(props) {
    this.roomID = props.roomID;
    this.ws = props.ws;
    this.bus = props.bus;
    this.actor = props.actor;
    this.id = props.listID;

    var _ListInterpreter$newL = ListInterpreter.newList(props.docID, props.listID),
        meta = _ListInterpreter$newL.meta,
        store = _ListInterpreter$newL.store;

    this.meta = meta;
    this.store = store;
    !props.checkpoint.lists[props.listID] ? process.env.NODE_ENV !== "production" ? invariant(false, "Unknown listid '" + props.listID + "' in checkpoint.") : invariant(false) : void 0;
    ListInterpreter.importFromRawCheckpoint(this.store, this.actor, props.checkpoint, this.meta.listID);
  }

  var _proto = InnerListClient.prototype;

  _proto.bootstrap = function bootstrap(actor, checkpoint) {
    this.actor = actor;
    ListInterpreter.importFromRawCheckpoint(this.store, this.actor, checkpoint.document, this.meta.listID);
  };

  _proto.sendCmd = function sendCmd(cmd) {
    this.ws.send('doc:cmd', {
      room: this.roomID,
      args: cmd
    });
    this.bus.publish({
      args: cmd,
      from: this.actor
    });
  };

  _proto.clone = function clone() {
    var cl = Object.assign(Object.create(Object.getPrototypeOf(this)), this);
    return cl;
  };

  _proto.dangerouslyUpdateClientDirectly = function dangerouslyUpdateClientDirectly(cmd, versionstamp, ack) {
    ListInterpreter.validateCommand(this.meta, cmd);
    ListInterpreter.applyCommand(this.store, cmd, versionstamp, ack);
    return this.clone();
  };

  _proto.get = function get(index) {
    return ListInterpreter.get(this.store, index);
  };

  _proto.set = function set(index, val) {
    if (val === undefined) {
      return this["delete"](index);
    }

    var cmd = ListInterpreter.runSet(this.store, this.meta, index, val); // Remote

    this.sendCmd(cmd);
    return this.clone();
  };

  _proto["delete"] = function _delete(index) {
    var cmd = ListInterpreter.runDelete(this.store, this.meta, index);

    if (!cmd) {
      return this.clone();
    } // Remote


    this.sendCmd(cmd);
    return this.clone();
  };

  _proto.insertAfter = function insertAfter(index, val) {
    return this.insertAt(index + 1, val);
  };

  _proto.insertAt = function insertAt(index, val) {
    var cmd = ListInterpreter.runInsertAt(this.store, this.meta, index, val); // Remote

    this.sendCmd(cmd);
    return this.clone();
  };

  _proto.push = function push() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var cmds = ListInterpreter.runPush.apply(ListInterpreter, [this.store, this.meta].concat(args));

    for (var _iterator = _createForOfIteratorHelperLoose(cmds), _step; !(_step = _iterator()).done;) {
      var cmd = _step.value;
      this.sendCmd(cmd);
    }

    return this;
  };

  _proto.map = function map(fn) {
    return ListInterpreter.map(this.store, fn);
  };

  _proto.toArray = function toArray() {
    return ListInterpreter.toArray(this.store);
  } //  exposed for testing
  ;

  _proto.session = function session() {
    return this.store.rt.session;
  };

  return InnerListClient;
}();

var InnerMapClient = /*#__PURE__*/function () {
  function InnerMapClient(props) {
    this.roomID = props.roomID;
    this.ws = props.ws;
    this.bus = props.bus;
    this.actor = props.actor;

    var _MapInterpreter$newMa = MapInterpreter.newMap(props.docID, props.mapID),
        store = _MapInterpreter$newMa.store,
        meta = _MapInterpreter$newMa.meta;

    this.store = store;
    this.meta = meta; //TODO: defer initial bootstrap?

    MapInterpreter.importFromRawCheckpoint(this.store, props.checkpoint, this.meta.mapID);
  }

  var _proto = InnerMapClient.prototype;

  _proto.bootstrap = function bootstrap(actor, checkpoint) {
    this.actor = actor;
    MapInterpreter.importFromRawCheckpoint(this.store, checkpoint.document, this.meta.mapID);
  };

  _proto.sendCmd = function sendCmd(cmd) {
    this.ws.send('doc:cmd', {
      room: this.roomID,
      args: cmd
    });
    this.bus.publish({
      from: this.actor,
      args: cmd
    });
  };

  _proto.clone = function clone() {
    return Object.assign(Object.create(Object.getPrototypeOf(this)), this);
  };

  _proto.dangerouslyUpdateClientDirectly = function dangerouslyUpdateClientDirectly(cmd, versionstamp, ack) {
    MapInterpreter.validateCommand(this.meta, cmd);
    MapInterpreter.applyCommand(this.store, cmd, versionstamp, ack);
    return this.clone();
  };

  _proto.get = function get(key) {
    var _this$store$kv$get;

    return (_this$store$kv$get = this.store.kv.get(key)) === null || _this$store$kv$get === void 0 ? void 0 : _this$store$kv$get.value;
  };

  _proto.set = function set(key, value) {
    if (value === undefined) {
      return this["delete"](key);
    }

    var cmd = MapInterpreter.runSet(this.store, this.meta, key, value); // Remote

    this.sendCmd(cmd);
    return this.clone();
  };

  _proto.toObject = function toObject() {
    var obj = {};

    for (var _iterator = _createForOfIteratorHelperLoose(this.keys), _step; !(_step = _iterator()).done;) {
      var key = _step.value;
      obj[key] = this.get(key);
    }

    return obj;
  };

  _proto["delete"] = function _delete(key) {
    var cmd = MapInterpreter.runDelete(this.store, this.meta, key); // remote

    this.sendCmd(cmd);
    return this.clone();
  };

  _createClass(InnerMapClient, [{
    key: "id",
    get: function get() {
      return this.meta.mapID;
    }
  }, {
    key: "keys",
    get: function get() {
      return Array.from(this.store.kv.entries()).filter(function (_ref) {
        var v = _ref[1];
        return v.value !== undefined;
      }).map(function (_ref2) {
        var k = _ref2[0];
        return k;
      });
    }
  }]);

  return InnerMapClient;
}();

function throttleByFirstArgument(callback, wait, immediate) {
  if (immediate === void 0) {
    immediate = false;
  }

  // @ts-ignore
  var timeouts = {};
  var initialCall = true;
  return function () {
    var _arguments = arguments,
        _this = this;

    var callNow = immediate && initialCall;

    var next = function next() {
      // @ts-ignore
      callback.apply(_this, _arguments); // @ts-ignore

      timeouts[_arguments[0]] = null;
    };

    if (callNow) {
      initialCall = false;
      next();
    } // @ts-ignore


    if (!timeouts[arguments[0]]) {
      timeouts[arguments[0]] = setTimeout(next, wait);
    }
  };
}

var InnerPresenceClient = /*#__PURE__*/function () {
  function InnerPresenceClient(props) {
    var _this = this;

    this.roomID = props.roomID;
    this.ws = props.ws;
    this.actor = props.actor;
    this.key = props.key;
    this.cache = {};
    this.bus = props.bus;

    var sendPres = function sendPres(_, args) {
      _this.ws.send('presence:cmd', args);
    };

    this.sendPres = throttleByFirstArgument(sendPres, 40);
    this.bootstrap(this.actor, props.checkpoint);
  }

  var _proto = InnerPresenceClient.prototype;

  _proto.bootstrap = function bootstrap(actor, checkpoint) {
    this.actor = actor;
    this.cache = _extends({}, this.cache, checkpoint.presence[this.key] || {});
  }
  /**
   * Gets all values for the presence key this client was created with,
   * organized by user id.
   */
  ;

  _proto.getAll = function getAll() {
    return this.withoutExpired();
  }
  /**
   * Gets the current user's value.
   */
  ;

  _proto.getMine = function getMine() {
    var _this$actor;

    return (_this$actor = (this.cache || {})[this.actor]) === null || _this$actor === void 0 ? void 0 : _this$actor.value;
  };

  _proto.withoutExpired = function withoutExpired() {
    var result = {};

    for (var actor in this.cache) {
      var obj = this.cache[actor];

      if (new Date() > obj.expAt) {
        delete this.cache[actor];
        continue;
      }

      result[actor] = obj.value;
    }

    return result;
  };

  _proto.withoutActorOrExpired = function withoutActorOrExpired(actor) {
    var result = {};

    for (var a in this.cache) {
      var obj = this.cache[a];
      if (!obj) continue; // remove this actor

      if (a === actor && this.cache[a]) {
        delete this.cache[a];
        continue;
      } // Remove expired


      if (new Date() > obj.expAt) {
        delete this.cache[a];
        continue;
      }

      result[a] = obj.value;
    }

    return result;
  }
  /**
   * @param value Any arbitrary object, string, boolean, or number.
   * @param exp (Optional) Expiration time in seconds
   */
  ;

  _proto.set = function set(value, exp) {
    var _this2 = this;

    var addition = exp ? exp : 60; // Convert to unix + add seconds

    var expAt = Math.round(new Date().getTime() / 1000) + addition;

    if (this.myExpirationHandle) {
      clearTimeout(this.myExpirationHandle);
      this.myExpirationHandle = undefined;
    }

    this.myExpirationHandle = setTimeout(function () {
      //  TODO: this should be revisited when presence ACKs are added
      delete _this2.cache[_this2.actor];

      _this2.bus.publish({
        key: _this2.key,
        valuesByUser: _this2.withoutExpired()
      });
    }, addition * 1000);
    this.sendPres(this.key, {
      room: this.roomID,
      key: this.key,
      value: JSON.stringify(value),
      expAt: expAt
    });
    this.cache[this.actor] = {
      value: value,
      expAt: new Date(expAt * 1000)
    };
    var result = this.withoutExpired();
    this.bus.publish({
      key: this.key,
      valuesByUser: result
    });
    return result;
  };

  _proto.dangerouslyUpdateClientDirectly = function dangerouslyUpdateClientDirectly(type, body) {
    if (type === 'room:rm_guest') {
      return this.withoutActorOrExpired(body.guest);
    }

    if (type === 'presence:expire') {
      var foo = this.withoutExpired();
      return foo;
    }

    if (body.room !== this.roomID) return false; // ignore validation msgs
    // TODO: use same ack logic as doc cmds

    if (body.from === this.actor) return false;
    var obj = {
      expAt: new Date(body.expAt * 1000),
      value: JSON.parse(body.value)
    };
    this.cache[body.from] = obj;
    return this.withoutExpired();
  };

  return InnerPresenceClient;
}();

var errNoInfiniteLoop = function errNoInfiniteLoop() {
  return new Error('Infinite loop detected, see more: See more: https://err.sh/getroomservice/browser/infinite-loop');
};

// Local pubsub, so that if you call .set in one place
// it will trigger a .subscribe elsewhere, without
// needing to go through the websockets

var LocalBus = /*#__PURE__*/function () {
  function LocalBus() {
    this.isPublishing = false;
    this.subs = new Set();
  }

  var _proto = LocalBus.prototype;

  _proto.unsubscribe = function unsubscribe(fn) {
    this.subs["delete"](fn);
  };

  _proto.subscribe = function subscribe(fn) {
    this.subs.add(fn);
    return fn;
  };

  _proto.publish = function publish(msg) {
    // This is an infinite loop
    if (this.isPublishing) {
      throw errNoInfiniteLoop();
    }

    this.isPublishing = true;
    this.subs.forEach(function (fn) {
      fn(msg);
    });
    this.isPublishing = false;
  };

  return LocalBus;
}();

var createRoom = function createRoom(params) {
  try {
    return Promise.resolve(fetchSession({
      authBundle: {
        strategy: params.authStrategy,
        ctx: params.authCtx
      },
      room: params.room,
      document: params.document
    })).then(function (session) {
      return Promise.resolve(fetchBootstrapState({
        docsURL: params.docsURL,
        presenceURL: params.presenceURL,
        token: session.token,
        docID: session.docID,
        roomID: session.roomID
      })).then(function (bootstrapState) {
        var roomClient = new RoomClient({
          actor: session.guestReference,
          bootstrapState: bootstrapState,
          token: session.token,
          room: params.room,
          document: params.document,
          auth: params.authStrategy,
          authCtx: params.authCtx,
          wsURL: WS_URL,
          docsURL: DOCS_URL,
          presenceURL: PRESENCE_URL,
          session: session
        });
        return roomClient;
      });
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var MAP_CMDS = ['mcreate', 'mput', 'mputref', 'mdel'];
var LIST_CMDS = ['lcreate', 'lins', 'linsref', 'lput', 'lputref', 'ldel'];
var RoomClient = /*#__PURE__*/function () {
  function RoomClient(params) {
    this.presenceClients = {};
    this.listClients = {};
    this.mapClients = {};
    this.expiresByActorByKey = {};
    this.queueIncomingCmds = true;
    this.cmdQueue = [];
    this.mapCallbacksByObjID = {};
    this.listCallbacksByObjID = {};
    this.presenceCallbacksByKey = {};
    var wsURL = params.wsURL,
        docsURL = params.docsURL,
        presenceURL = params.presenceURL,
        room = params.room,
        document = params.document;
    this.ws = new ReconnectingWebSocket({
      dispatcher: this,
      wsURL: wsURL,
      docsURL: docsURL,
      presenceURL: presenceURL,
      room: room,
      document: document,
      authBundle: {
        strategy: params.auth,
        ctx: params.authCtx
      },
      sessionFetch: function sessionFetch(_) {
        //  TODO: implement re-fetching of sessions when stale
        return Promise.resolve(params.session);
      }
    });
    this.roomID = params.session.roomID;
    this.docID = params.bootstrapState.document.id;
    this.actor = params.actor;
    this.bootstrapState = params.bootstrapState;
  } //  impl WebsocketDispatch


  var _proto = RoomClient.prototype;

  _proto.forwardCmd = function forwardCmd(msgType, body) {
    if (this.queueIncomingCmds) {
      this.cmdQueue.push([msgType, body]);
      return;
    }

    this.processCmd(msgType, body);
  };

  _proto.processCmd = function processCmd(msgType, body) {
    if (msgType == 'doc:fwd' && 'args' in body) {
      this.dispatchDocCmd(body);
    }

    if (msgType == 'presence:fwd' && 'expAt' in body) {
      this.dispatchPresenceCmd(body);
    }

    if (msgType == 'room:rm_guest' && 'guest' in body) {
      this.dispatchRmGuest(body);
    }
  };

  _proto.bootstrap = function bootstrap(actor, state) {
    this.actor = actor;
    this.bootstrapState = state;

    for (var _i = 0, _Object$entries = Object.entries(this.listClients); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _Object$entries[_i],
          client = _Object$entries$_i[1];
      client.bootstrap(actor, state);
    }

    for (var _i2 = 0, _Object$entries2 = Object.entries(this.mapClients); _i2 < _Object$entries2.length; _i2++) {
      var _Object$entries2$_i = _Object$entries2[_i2],
          _client = _Object$entries2$_i[1];

      _client.bootstrap(actor, state);
    }

    for (var _i3 = 0, _Object$entries3 = Object.entries(this.presenceClients); _i3 < _Object$entries3.length; _i3++) {
      var _Object$entries3$_i = _Object$entries3[_i3],
          _client2 = _Object$entries3$_i[1];

      _client2.bootstrap(actor, state);
    }

    this.queueIncomingCmds = false;

    for (var _iterator = _createForOfIteratorHelperLoose(this.cmdQueue), _step; !(_step = _iterator()).done;) {
      var _step$value = _step.value,
          msgType = _step$value[0],
          body = _step$value[1];
      this.processCmd(msgType, body);
    }

    this.cmdQueue.length = 0;
  };

  _proto.startQueueingCmds = function startQueueingCmds() {
    this.queueIncomingCmds = true;
  };

  _proto.dispatchDocCmd = function dispatchDocCmd(body) {
    if (body.room !== this.roomID) return;

    if (!body.args || body.args.length < 3) {
      // Potentially a network failure, we don't want to crash,
      // but do want to warn people
      console.error('Unexpected command: ', body.args);
      return;
    } // Ignore version stamps older than checkpoint


    if (isOlderVS(body.vs, this.bootstrapState.document.vs)) {
      return;
    }

    var _ref = [body.args[0], body.args[1], body.args[2]],
        cmd = _ref[0],
        docID = _ref[1],
        objID = _ref[2];
    if (docID !== this.docID) return;

    if (MAP_CMDS.includes(cmd)) {
      this.dispatchMapCmd(objID, body);
    } else if (LIST_CMDS.includes(cmd)) {
      this.dispatchListCmd(objID, body);
    } else {
      console.warn('Unhandled Room Service doc:fwd command: ' + cmd + '. Consider updating the Room Service client.');
    }
  };

  _proto.dispatchRmGuest = function dispatchRmGuest(body) {
    if (body.room !== this.roomID) return;

    for (var _i4 = 0, _Object$entries4 = Object.entries(this.presenceClients); _i4 < _Object$entries4.length; _i4++) {
      var _Object$entries4$_i = _Object$entries4[_i4],
          key = _Object$entries4$_i[0],
          presenceClient = _Object$entries4$_i[1];
      var newClient = presenceClient.dangerouslyUpdateClientDirectly('room:rm_guest', body);
      if (!newClient) return;

      for (var _iterator2 = _createForOfIteratorHelperLoose(this.presenceCallbacksByKey[key] || []), _step2; !(_step2 = _iterator2()).done;) {
        var cb = _step2.value;
        cb(newClient, body.guest);
      }
    }
  };

  _proto.dispatchMapCmd = function dispatchMapCmd(objID, body) {
    if (!this.mapClients[objID]) {
      this.createMapLocally(objID);
    }

    var client = this.mapClients[objID];
    var updatedClient = client.dangerouslyUpdateClientDirectly(body.args, body.vs, body.ack);

    for (var _iterator3 = _createForOfIteratorHelperLoose(this.mapCallbacksByObjID[objID] || []), _step3; !(_step3 = _iterator3()).done;) {
      var cb = _step3.value;
      cb(updatedClient.toObject(), body.from);
    }
  };

  _proto.dispatchListCmd = function dispatchListCmd(objID, body) {
    if (!this.listClients[objID]) {
      this.createListLocally(objID);
    }

    var client = this.listClients[objID];
    var updatedClient = client.dangerouslyUpdateClientDirectly(body.args, body.vs, body.ack);

    for (var _iterator4 = _createForOfIteratorHelperLoose(this.listCallbacksByObjID[objID] || []), _step4; !(_step4 = _iterator4()).done;) {
      var cb = _step4.value;
      cb(updatedClient.toArray(), body.from);
    }
  };

  _proto.dispatchPresenceCmd = function dispatchPresenceCmd(body) {
    var _this = this;

    if (body.room !== this.roomID) return; //  TODO: use same ack logic as doc cmds

    if (body.from === this.actor) return;
    var key = body.key;
    var client = this.presence(key);
    var now = new Date().getTime() / 1000;
    var secondsTillTimeout = body.expAt - now;

    if (secondsTillTimeout < 0) {
      // don't show expired stuff
      return;
    } // Expire stuff if it's within a reasonable range (12h)


    if (secondsTillTimeout < 60 * 60 * 12) {
      var expiresByActor = this.expiresByActorByKey[key] || {};
      var actor = body.from;

      if (expiresByActor[actor]) {
        clearTimeout(expiresByActor[actor]);
      }

      var timeout = setTimeout(function () {
        var newClient = client.dangerouslyUpdateClientDirectly('presence:expire', {
          key: body.key
        });
        if (!newClient) return;

        for (var _iterator5 = _createForOfIteratorHelperLoose((_this$presenceCallbac = _this.presenceCallbacksByKey[key]) !== null && _this$presenceCallbac !== void 0 ? _this$presenceCallbac : []), _step5; !(_step5 = _iterator5()).done;) {
          var _this$presenceCallbac;

          var cb = _step5.value;
          cb(newClient, body.from);
        }
      }, secondsTillTimeout * 1000);
      expiresByActor[actor] = timeout;
      this.expiresByActorByKey[key] = expiresByActor;
    }

    var newClient = client.dangerouslyUpdateClientDirectly('presence:fwd', body);
    if (!newClient) return;

    for (var _iterator6 = _createForOfIteratorHelperLoose((_this$presenceCallbac2 = this.presenceCallbacksByKey[key]) !== null && _this$presenceCallbac2 !== void 0 ? _this$presenceCallbac2 : []), _step6; !(_step6 = _iterator6()).done;) {
      var _this$presenceCallbac2;

      var cb = _step6.value;
      cb(newClient, body.from);
    }
  };

  _proto.createListLocally = function createListLocally(name) {
    var _this2 = this;

    var bus = new LocalBus();
    bus.subscribe(function (body) {
      var client = _this2.listClients[name];

      for (var _iterator7 = _createForOfIteratorHelperLoose(_this2.listCallbacksByObjID[name] || []), _step7; !(_step7 = _iterator7()).done;) {
        var cb = _step7.value;
        cb(client.toArray(), body.from);
      }
    });
    var l = new InnerListClient({
      checkpoint: this.bootstrapState.document,
      roomID: this.roomID,
      docID: this.docID,
      listID: name,
      ws: this.ws,
      actor: this.actor,
      bus: bus
    });
    this.listClients[name] = l;
    return l;
  };

  _proto.list = function list(name) {
    if (this.listClients[name]) {
      return this.listClients[name];
    } // create a list if it doesn't exist


    if (!this.bootstrapState.document.lists[name]) {
      this.ws.send('doc:cmd', {
        args: ['lcreate', this.docID, name],
        room: this.roomID
      }); // Assume success

      this.bootstrapState.document.lists[name] = {
        afters: [],
        ids: [],
        values: []
      };
    }

    return this.createListLocally(name);
  };

  _proto.createMapLocally = function createMapLocally(name) {
    var _this3 = this;

    var bus = new LocalBus();
    bus.subscribe(function (body) {
      var client = _this3.mapClients[name];

      for (var _iterator8 = _createForOfIteratorHelperLoose(_this3.mapCallbacksByObjID[name] || []), _step8; !(_step8 = _iterator8()).done;) {
        var cb = _step8.value;
        cb(client.toObject(), body.from);
      }
    });
    var m = new InnerMapClient({
      checkpoint: this.bootstrapState.document,
      roomID: this.roomID,
      docID: this.docID,
      mapID: name,
      ws: this.ws,
      bus: bus,
      actor: this.actor
    });
    this.mapClients[name] = m;
    return m;
  };

  _proto.map = function map(name) {
    if (this.mapClients[name]) {
      return this.mapClients[name];
    } // Create this map if it doesn't exist


    if (!this.bootstrapState.document.maps[name]) {
      this.ws.send('doc:cmd', {
        args: ['mcreate', this.docID, name],
        room: this.roomID
      });
    }

    return this.createMapLocally(name);
  };

  _proto.presence = function presence(key) {
    var _this4 = this;

    if (this.presenceClients[key]) {
      return this.presenceClients[key];
    }

    var bus = new LocalBus();
    bus.subscribe(function (body) {
      for (var _iterator9 = _createForOfIteratorHelperLoose(_this4.presenceCallbacksByKey[body.key] || []), _step9; !(_step9 = _iterator9()).done;) {
        var cb = _step9.value;
        cb(body.valuesByUser, _this4.actor);
      }
    });
    var p = new InnerPresenceClient({
      checkpoint: this.bootstrapState,
      roomID: this.roomID,
      actor: this.actor,
      ws: this.ws,
      key: key,
      bus: bus
    });

    try {
      this.presenceClients[key] = p;
    } catch (err) {
      throw new Error("Don't Freeze State. See more: https://err.sh/getroomservice/browser/dont-freeze");
    }

    return this.presenceClients[key];
  };

  _proto.subscribe = function subscribe(obj, onChangeFn) {
    // Presence handler
    if (obj instanceof InnerPresenceClient) {
      return this.subscribePresence(obj, onChangeFn);
    } // create new closure so fns can be subscribed/unsubscribed multiple times


    var cb = function cb(obj, from) {
      onChangeFn(obj, from);
    };

    var objID;

    if (obj instanceof InnerMapClient) {
      var client = obj;
      objID = client.id;
      this.mapCallbacksByObjID[objID] = this.mapCallbacksByObjID[objID] || [];
      this.mapCallbacksByObjID[objID].push(cb);
    }

    if (obj instanceof InnerListClient) {
      var _client3 = obj;
      objID = _client3.id;
      this.listCallbacksByObjID[objID] = this.listCallbacksByObjID[objID] || [];
      this.listCallbacksByObjID[objID].push(cb);
    }

    return [{
      objID: objID,
      fn: cb
    }];
  };

  _proto.subscribePresence = function subscribePresence(obj, onChangeFn) {
    !obj ? process.env.NODE_ENV !== "production" ? invariant(false, 'subscribe() expects the first argument to not be undefined.') : invariant(false) : void 0; //  create new closure so fns can be subscribed/unsubscribed multiple times

    var cb = function cb(obj, from) {
      if (onChangeFn) {
        onChangeFn(obj, from);
      }
    };

    var key = obj.key;
    this.presenceCallbacksByKey[key] = this.presenceCallbacksByKey[key] || [];
    this.presenceCallbacksByKey[key].push(cb);
    return [{
      objID: key,
      fn: cb
    }];
  };

  _proto.unsubscribe = function unsubscribe(listeners) {
    for (var _iterator10 = _createForOfIteratorHelperLoose(listeners), _step10; !(_step10 = _iterator10()).done;) {
      var l = _step10.value;

      if (l.objID) {
        this.mapCallbacksByObjID[l.objID] = removeCallback(this.mapCallbacksByObjID[l.objID], l.fn);
        this.listCallbacksByObjID[l.objID] = removeCallback(this.listCallbacksByObjID[l.objID], l.fn);
        this.presenceCallbacksByKey[l.objID] = removeCallback(this.presenceCallbacksByKey[l.objID], l.fn);
      }
    }
  };

  _createClass(RoomClient, [{
    key: "me",
    get: function get() {
      return this.actor;
    }
  }]);

  return RoomClient;
}();

function removeCallback(cbs, rmCb) {
  if (!cbs) {
    return [];
  }

  return cbs.filter(function (existingCb) {
    return existingCb !== rmCb;
  });
}

var RoomService = /*#__PURE__*/function () {
  function RoomService(params) {
    this.roomClients = {};
    this.auth = params.auth;
    this.ctx = params.ctx || {};
  }

  var _proto = RoomService.prototype;

  _proto.room = function room(name) {
    try {
      var _this2 = this;

      if (_this2.roomClients[name]) {
        return Promise.resolve(_this2.roomClients[name]);
      }

      return Promise.resolve(createRoom({
        docsURL: DOCS_URL,
        presenceURL: PRESENCE_URL,
        authStrategy: _this2.auth,
        authCtx: _this2.ctx,
        room: name,
        document: 'default'
      })).then(function (client) {
        _this2.roomClients[name] = client;
        return client;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return RoomService;
}();

export default RoomService;
export { RoomClient, RoomService };
//# sourceMappingURL=browser.esm.js.map
